import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Megaphone, X } from "lucide-react";

/** Platform-broadcast banner shown across the top of the tenant app. Fetched
 *  from `/api/announcements/active` on mount; refreshes every 5 minutes.
 *  Users can dismiss individual announcements (persisted in localStorage). */
export default function AnnouncementBanner() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return new Set(JSON.parse(localStorage.getItem("zenith_ann_dismissed") || "[]")); } catch { return new Set(); }
  });

  useEffect(() => {
    const pull = () => api.get("/announcements/active").then((r) => setItems(r.data)).catch(() => {});
    pull();
    const t = setInterval(pull, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  const dismiss = (id) => {
    const next = new Set(dismissed); next.add(id);
    setDismissed(next);
    try { localStorage.setItem("zenith_ann_dismissed", JSON.stringify([...next])); } catch { /* noop */ }
  };

  const visible = items.filter((a) => !dismissed.has(a.id));
  if (visible.length === 0) return null;

  return (
    <div className="w-full" data-testid="announcement-banner">
      {visible.map((a) => {
        const tone = a.severity === "critical" ? "bg-red-500 text-white"
          : a.severity === "warning" ? "bg-amber-500 text-black" : "bg-blue-500 text-white";
        return (
          <div key={a.id} className={`${tone} px-4 py-2 text-sm flex items-center gap-3`} data-testid={`ann-${a.id.slice(0,8)}`}>
            <Megaphone className="w-4 h-4 shrink-0" />
            <div className="flex-1"><b>{a.title}</b> · <span className="opacity-90">{a.body}</span></div>
            <button onClick={() => dismiss(a.id)} className="opacity-80 hover:opacity-100" data-testid={`ann-dismiss-${a.id.slice(0,8)}`}><X className="w-4 h-4" /></button>
          </div>
        );
      })}
    </div>
  );
}
